<script>
import { mapState } from "vuex";

export default {
  name: "AgreeDoc",

  computed: {
    ...mapState({
      licenseAgreement: (state) => state.tariffDocs.documents.licenseAgreement,
    }),
  },
};
</script>

<template>
  <div class="agree-doc" v-html="licenseAgreement" />
</template>

<style lang="scss" scoped>
.agree-doc {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &:deep(h4) {
    color: var(--text-dark-primary, #212121);

    @include body-1-bold;
  }

  &:deep(p) {
    color: var(--text-dark-primary, #212121);

    @include body-1;
  }

  &:deep(ul) {
    display: flex;
    flex-direction: column;
    gap: 8px;

    > li {
      color: var(--text-dark-primary, #212121);

      @include body-1;
    }
  }
}
</style>
